import { api } from "@/http/api-client"

import type { TChangelogService, TListServicesResponse } from "./types"

export type TListServicesParams = {
  organizationSlug: string
}

export function listServices(params: TListServicesParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TListServicesResponse>(
    `/changelog/services?${searchParams.toString()}`,
  )
}

export type TGetServiceParams = {
  serviceId: string
  organizationSlug: string
}

export function getService(params: TGetServiceParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TChangelogService>(
    `/changelog/services/${params.serviceId}?${searchParams.toString()}`,
  )
}

export type TCreateServiceParams = {
  name: string
  slug?: string
  description?: string
  isPublic?: boolean
  organizationSlug: string
}

export function createService(params: TCreateServiceParams) {
  return api.post<TChangelogService>("/changelog/services", {
    json: params,
  })
}

export type TUpdateServiceParams = {
  serviceId: string
  name?: string
  slug?: string
  description?: string | null
  isPublic?: boolean
  organizationSlug: string
}

export function updateService(params: TUpdateServiceParams) {
  const { serviceId, ...body } = params
  return api.patch<TChangelogService>(`/changelog/services/${serviceId}`, {
    json: body,
  })
}

export type TDeleteServiceParams = {
  serviceId: string
  organizationSlug: string
}

export function deleteService(params: TDeleteServiceParams) {
  return api.delete(`/changelog/services/${params.serviceId}`, {
    json: { organizationSlug: params.organizationSlug },
  })
}
